<template>
    <div class="">
        <Status />
        <br/>
        <Responsible />
        <Projects />
        <Equipment />
        <Teachers />
        <Courses />
        <div class="line"></div>
        <div class="title-part">Мероприятия</div>
        <Events />
        <div class="line"></div>
        <CountPupils />
    </div>
</template>

<script>
import Status from '../Status'
import Projects from './projects'
import Responsible from '../Responsible'
import Equipment from './Equipment'
import Teachers from './Teachers'
import Courses from './Courses'
import Events from './Events'
import Graduates from '../Graduates'
//import CooperationProf from './cooperation/CooperationProf'
import CountPupils from './CountPupils'
export default {
    name: "index",
    components: {
        Status,
        Responsible,
        Equipment,
        Teachers,
        Courses,
        Events,
        CountPupils,
        Projects
    },
}
</script>

<style scoped>

</style>
